<template>
  <div>

  </div>
</template>

<script>

export default {
  name: 'LinkApp',
  data() {
    return {
      id: null
    };
  },

  created() {
    if(this.$route.params.id) {
      this.buscarLink(atob(this.$route.params.id));
    }
  },

  methods: {
    buscarLink(id) {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/buscarLinkApp', id)
        .then((response) => {
          const isAndroid = navigator.userAgent.toLowerCase().includes('android');
          const isiOS = /(iPhone|iPod|iPad)/i.test(navigator.userAgent);

          if (isAndroid) {
            window.location.href = response.data.link_android;
          } else if (isiOS) {
            window.location.href = response.data.link_apple;
          } else {
            window.location.href = response.data.link_android;
          }
        })
        .catch(() => this.makeToast('Oopss', 'Erro ao buscar dados!', 'danger'))
        .finally(() => this.$store.dispatch('endLoader'));
    }
  }
};
</script>
